export default [
  // {
  //   session_id: 'on_boarding',
  // },
  { session_id: '1', slogan: 'aspire', duration: '90' },
  { session_id: '2', slogan: 'focus', duration: '60' },
  { session_id: '3', slogan: 'commit', duration: '90' },
  { session_id: '4', slogan: 'grow', duration: '90' },
  { session_id: '5', slogan: 'grow', duration: '90' },
  { session_id: '6', slogan: 'grow', duration: '90' },
  { session_id: '7', slogan: 'grow', duration: '90' },
  { session_id: '8', slogan: 'grow', duration: '90' },
  { session_id: '9', slogan: 'grow', duration: '90' },
  { session_id: '10', slogan: 'grow', duration: '60' },
  { session_id: '11', slogan: 'grow', duration: '90' },
  { session_id: '12', slogan: 'grow', duration: '90' },
  { session_id: '13', slogan: 'grow', duration: '90' },
];
